import { styled } from "@compiled/react";
import * as Sentry from "@sentry/react";

import { useConfig } from "../../hooks";

import {
    isUnpublishedEntry,
    isUnpublishedAsset
} from "./view-model-error.types";

export type ViewModelErrorProps = {
    model: unknown;
};

export const ViewModelError = ({ model }: ViewModelErrorProps) => {
    if (isUnpublishedEntry(model) || isUnpublishedAsset(model)) {
        Sentry.captureException(new Error("View Model Error"), {
            tags: {
                team: "bxpt",
                modelType: model.sys.linkType,
                contentId: model.sys.id
            }
        });
    }

    const { environment } = useConfig();

    if (environment === "production") {
        return null;
    }

    const goToUrl = `https://app.contentful.com/spaces/rz1oowkt5gyp/environments/${environment}`;

    return (
        <WarningBlock>
            {isUnpublishedEntry(model) && (
                <>
                    <WarningText>
                        There is an unpublished <b>entry</b> here.
                    </WarningText>
                    <WarningLink href={`${goToUrl}/entries/${model.sys.id}`}>
                        Go to entry ID: {model.sys.id}
                    </WarningLink>
                </>
            )}
            {isUnpublishedAsset(model) && (
                <>
                    <WarningText>
                        There is an unpublished <b>asset</b> here.
                    </WarningText>
                    <WarningLink href={`${goToUrl}/assets/${model.sys.id}`}>
                        Go to asset ID: {model.sys.id}
                    </WarningLink>
                </>
            )}
        </WarningBlock>
    );
};

const WarningBlock = styled.div`
    background-color: transparent;
    color: inherit;
    border-radius: 0.75rem;
    padding: 0.75rem 1.5rem;
    margin-bottom: 1rem !important;
    /* eslint-disable-next-line local/ensure-wac-token-usage -- Error component, hard-coded color acceptable */
    border: 2px dashed #de350b;
`;

const WarningText = styled.div({
    fontSize: "1.25rem"
});

const WarningLink = styled.a({
    fontSize: "1rem",
    textUnderlineOffset: "0.25rem"
});
